/**
 * The handful of glyphs the navigation needs.
 *
 * Hand-drawn rather than pulled from an icon package: nine outlines do not
 * justify a dependency in an app that has to install and run with no network,
 * and inline SVG inherits `currentColor` so the nav states need no icon-specific
 * styling.
 */

export type IconName =
  | 'grid'
  | 'wheel'
  | 'clipboard'
  | 'clock'
  | 'invoice'
  | 'export'
  | 'shield'
  | 'settings'
  | 'more'
  | 'lock';

const PATHS: Record<IconName, string> = {
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  wheel: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6M12 3v6M4.3 16.5l5.2-3M19.7 16.5l-5.2-3',
  clipboard: 'M9 4h6v3H9zM9 5.5H7a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6.5a1 1 0 0 0-1-1h-2M9 12h6M9 16h4',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7.5V12l3 2',
  invoice: 'M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7zM14 3v4h4M9 12h6M9 16h4',
  export: 'M12 3v12M8 11l4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2',
  shield: 'M12 3l8 3v6c0 4.4-3.2 8.2-8 9.5C7.2 20.2 4 16.4 4 12V6zM9 12l2 2 4-4',
  settings: 'M4 7h8M16 7h4M4 17h4M12 17h8M14 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0M8 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  lock: 'M7 10V7a5 5 0 0 1 10 0v3M6 10h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1',
};

export function Icon({ name, className = 'h-5 w-5' }: { name: IconName; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
